import { atom } from 'recoil';
import type { Utils } from '@sparrow-marketing/contracts';

export const CacheCustomMetricsState = atom<Utils.DynamicObject<string, any>>({
  key: 'cache-custom-metrics-state',
  default: {},
});
